import React, {
  useEffect,
} from 'react';
import {
  MainPreview,
  MainServices,
  MainNews,
  MainEvents,
} from 'containers';
import { setPageMeta, routes } from 'appConstants';

const Main = () => {
  useEffect(() => {
    setPageMeta(routes.main.title, routes.main.descr);

    const saveScrollPoint = () => {
      sessionStorage.setItem('mainScrollTop', String(window.scrollY));
    };

    if (sessionStorage.getItem('mainScrollTop') !== '0') {
      const topScroll = Number.parseInt(sessionStorage.getItem('mainScrollTop') || '', 10);
      setTimeout(() => {
        window.scrollTo({
          top: topScroll,
          behavior: 'smooth',
        });
      }, 50);
    }

    window.addEventListener('scroll', saveScrollPoint);
    return () => {
      window.removeEventListener('scroll', saveScrollPoint);
    };
  }, []);

  return (
    <>
      <MainPreview />
      <MainServices />
      <MainEvents />
      <MainNews />
    </>
  );
};

export default Main;
